import { useEffect, useState } from "react";
import { Select } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../../api";


const TestUnitSelect = ({ value, onChange, placeholder = "Select Test Unit", ...props }) => {
  const [testUnits, setTestUnits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestUnits = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/textInfo/type/testUnit`);
        setTestUnits(response.data);
      } catch (_error) {
        console.error("Error fetching super groups:", _error);
        setTestUnits([]);
      } finally {
        setLoading(false);
      }
    };
    fetchTestUnits();
  }, []);

  return (
    <Select
      showSearch
      defaultValue={value}
      value={value}
      onChange={(val) => {
        if (onChange) onChange(val);
      }}
      placeholder={placeholder}
      loading={loading}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      { testUnits.map((testUnit) => (
        <Select.Option key={testUnit._id} value={testUnit.value}>
          {testUnit.value}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TestUnitSelect;
